<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      :inContainerQty="inContainerQty"
      @reload="getData"
    >
      <template #header>
        <div class="d-flex align-items-center">
          <h6 class="m-0" style="color:#101010">
            {{ $l('title_packing_ratio') || '装箱配比' }}
          </h6>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <el-button
            v-if="!disabled"
            size="mini"
            class="ml-1"
            type="success"
            plain
            @click="addUniqueSku()"
          >
            {{ $l('btn_addUniqueSku') || '添加独码独色产品' }}
          </el-button>
          <el-button
            v-if="!disabled"
            size="mini"
            class="ml-1"
            type="primary"
            plain
            @click="addMixedSku()"
          >
            {{ $l('btn_addMixedSku') || '添加混装产品' }}
          </el-button>
        </div>
      </template>
    </PageMain>

    <ChooseSku
      :title="$l('dialog_title_addUniqueSku') || '添加独码独色产品'"
      :visible.sync="addUniqueSkuVisible"
      :platformCode="platformCode"
      @confirm="uniqueSkuConfirm"
    />

    <MixedSku
      :visible.sync="addMixedSkuVisible"
      :platformCode="platformCode"
      @confirm="mixedSkuConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import ChooseSku from '../choose-sku'
import MixedSku from '../mixed-sku'
export default {
  components: { PageMain, ChooseSku, MixedSku },
  props: {
    evgPackingSchemeCode: { type: String, default: '' },
    platformCode: { type: String, default: '' },
    inContainerQty: { type: Number, default: 0 },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      addUniqueSkuVisible: false,
      addMixedSkuVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.evgPackingSchemeCode) return
      this.loading = true
      const res = await this.$api
        .ecomEvgPackingSchemeSkuListApi({
          evgPackingSchemeCode: this.evgPackingSchemeCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      const data = res.body?.data || []
      this.tableData = data.map((item) => {
        const { items, ...row } = item
        const rowKey = row.evgSkuPlatformCode || row.evgPackingCartonCode
        return {
          ...row,
          rowKey,
          items:
            items?.map((t) => ({
              ...t,
              rowKey: `${row.evgPackingCartonCode}-${t.evgSkuPlatformCode}`,
              parentRowKey: rowKey,
            })) || [],
        }
      })

      setTimeout(() => {
        this.$refs.main.calcTotal()
        this.$refs.main.setAllTreeExpand()
      }, 0)
    },
    addUniqueSku() {
      if (!this.platformCode) {
        this.$message({
          message:
            this.$l('tips_warning_chooseSku_platformCode_empty') ||
            '请先选择渠道后，在添加产品！',
          type: 'warning',
        })
        return
      }
      this.addUniqueSkuVisible = true
    },
    uniqueSkuConfirm(data) {
      if (!data?.length) return

      const tableData = this.getTableData()

      const rows = data
        .filter((item) => {
          const result = tableData.find(
            (row) => row.evgSkuPlatformCode === item.evgSkuPlatformCode
          )
          return !result
        })
        .map((row) => ({
          ...row,
          rowKey: row.evgSkuPlatformCode,
          ctnInPalletQty: 0,
          unitInCtnQty: row.sellableEachQty,
          packingType: 'A',
          v_packingType: this.$l('table_label_packingType_A') || '独码独色',
        }))

      if (!rows?.length) return
      this.$refs.main.insertAt(rows)
    },
    addMixedSku() {
      if (!this.platformCode) {
        this.$message({
          message:
            this.$l('tips_warning_chooseSku_platformCode_empty') ||
            '请先选择渠道后，在添加产品！',
          type: 'warning',
        })
        return
      }
      this.addMixedSkuVisible = true
    },
    async mixedSkuConfirm(data) {
      const { listSku, ...packing } = data
      if (!listSku?.length) return

      const tableData = this.getTableData()

      const rowKey = (tableData?.length || 0) + 1

      const {
        cartonType,
        v_cartonType,
        totalUnitInCtnQty,
        ctnInPalletQty,
      } = packing

      const packingDesc = listSku
        .map((sku) => {
          const { goodsColor, goodsColorEn, goodsPattern } = sku
          return [goodsColor, goodsColorEn, goodsPattern].filter(Boolean).join()
        })
        .filter(Boolean)
        .join(' + ')

      const row = {
        goodsName: packingDesc,
        rowKey: `${rowKey}`,
        packingDesc,
        cartonType,
        v_cartonType,
        unitInCtnQty: totalUnitInCtnQty,
        ctnInPalletQty,
        packingType: 'B',
        v_packingType: this.$l('table_label_packingType_B') || '混装',
        items: listSku.map((sku) => ({
          ...sku,
          rowKey: `${rowKey}-${sku.evgSkuPlatformCode}`,
          parentRowKey: `${rowKey}`,
        })),
      }

      const $main = this.$refs.main
      const { row: newRow } = await $main.insertAt(row, -1, true)
      $main.setTreeExpand(newRow)
    },
    async validate() {
      const tableData = this.getTableData()

      if (!tableData?.length) {
        this.$message({
          message: this.$l('tips_warning_sku_empty') || '请添加装箱配比！',
          type: 'warning',
        })
      }

      const result = await this.$refs.main.validate()
      return result && tableData?.length
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    clear() {
      this.tableData = []
      this.$refs.main.clear()
    },
  },
}
</script>
